import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { InventoryPartListParams } from '../../../types/inventory/inventoryTypes'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const printInventoryPartList =
    (params: InventoryPartListParams) =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<boolean> => {
        const { userData } = getState()

        dispatch({
            type: storeDispatchTypes.setInventoryPrinting,
            value: true,
        })

        try {
            const response = await apiInstance.post(
                '/inventory/printInventoryPartList',
                {
                    userId: userData.smsAuth.userId,
                    params: {
                        ...params,
                        pagination: undefined,
                        includeFacets: false,
                    },
                },
                {
                    headers: {
                        Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
                    },
                    responseType: 'blob',
                },
            )

            const blob = new Blob([response.data], { type: 'application/pdf' })
            const header = await blob.slice(0, 5).text()

            if (header !== '%PDF-') {
                throw new Error('print inventory response is not a PDF')
            }

            const url = URL.createObjectURL(blob)
            window.open(url, '_blank')

            return true
        } catch (e) {
            console.error('print inventory parts failed', e)
            return false
        } finally {
            dispatch({
                type: storeDispatchTypes.setInventoryPrinting,
                value: false,
            })
        }
    }

export default printInventoryPartList
